import { render, staticRenderFns } from "./Music.vue?vue&type=template&id=7a33e545&scoped=true&"
import script from "./Music.vue?vue&type=script&lang=ts&"
export * from "./Music.vue?vue&type=script&lang=ts&"
import style0 from "./Music.vue?vue&type=style&index=0&id=7a33e545&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a33e545",
  null
  
)

export default component.exports